import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-a-loading-screen',
  standalone: true,
  imports: [],
  templateUrl: './a-loading-screen.component.html',
  styleUrl: './a-loading-screen.component.css'
})
export class ALoadingScreenComponent {
  option: any
  constructor(private readonly options: DynamicDialogConfig) {
    this.option = options.data
    console.log(this.option)
  }
}
